import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  currentlang: any;

  constructor(
    public translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');
    this.translate.use(this.currentlang);
    this.translate.setDefaultLang(this.currentlang);
  }
}